<template>
  <div>
    <div>
      <div class="formBox margbot" ref="searchBox">
        <el-form :inline="true" :model="formData" size="mini" label-width="90px">
          <div class="formItemBox">
            <el-form-item label="提货单号:" >
              <el-input
                class="ipt"
                v-model="formData.billNo"
                placeholder="请输入提货单号"
                size="mini"
              ></el-input>
            </el-form-item>
            <el-form-item label="创建时间:" >
              <div style="display: flex;">
              <el-date-picker
                v-model="formData.dateStart"
                size="mini"
                type="datetime"
                placeholder="选择创建时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
              -
              <el-date-picker
                v-model="formData.dateEnd"
                size="mini"
                placeholder="选择创建时间"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="一级货主:">
            <el-select
            size="mini"
            filterable
            clearable
            placeholder="请选择一级货主"
            v-model="formData.primaryCustomerTaxId"
            >
              <el-option
                v-for="(item, index) in HZData"
                :key="index"
                :label="item.custerName"
                :value="item.taxpayerNumber"
              >
              </el-option>
            </el-select>
            </el-form-item>
            <el-form-item label="二级货主:" >
            <el-select
            size="mini"
            clearable
            filterable
            placeholder="请选择二级货主"
            v-model="formData.secondaryCustomerTaxId"
            >
              <el-option
                v-for="(item, index) in HZData"
                :key="index"
                :label="item.custerName"
                :value="item.taxpayerNumber"
              >
              </el-option>
            </el-select>
            </el-form-item>
            <el-form-item label="车辆号牌:" >
              <el-input
                class="ipt"
                v-model="formData.plateNumber"
                placeholder="请输入车号"
                size="mini"
              ></el-input>
            </el-form-item>
            <el-form-item label="客户单号:" >
              <el-input
                class="ipt"
                v-model="formData.outBillNo"
                placeholder="请输入客户单号"
                size="mini"
              ></el-input>
            </el-form-item>
            <el-form-item label="预提单号:">
              <el-input
                class="ipt"
                v-model="formData.miniBillNo"
                placeholder="请输入预提单号"
                size="mini"
              ></el-input>
            </el-form-item>
            <el-form-item label="单据状态:">
            <el-select v-model="formData.miniBillType"  clearable placeholder="请选择" size="mini" >
              <el-option
                v-for="(item, index) in miniBillTypeData"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
          <el-form-item style="margin:10px 0 10px 0;">
            <el-button type="primary" size="mini" @click="chaxun" btnCode="00cP005B009" v-if="btnFlg[8]">查询</el-button>
            <el-button type="primary" size="mini" @click="chongzhi" btnCode="00cP005B00A" v-if="btnFlg[9]">重置</el-button>
            <el-button type="primary" size="mini" @click="deletedClcik" btnCode="00cP005B00B" v-if="btnFlg[10]">删除</el-button>
            <el-button type="primary" size="mini" @click="addPlan" btnCode="00cP005B00C" v-if="btnFlg[11]">添加出库计划</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div :style="{height:h}">
          <el-table
          border
          center
          bordersize="mini"
          :data="tableData"
          ref="tableData"
          height="100%"
          style="width:100%"
          size="mini"
          highlight-current-row
          :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
          @row-click="dianjiTable"
          >
            <!-- <el-table-column type="selection" align="center" width="40"></el-table-column> -->
            <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
            <el-table-column align="center" label="操作" width="120">
              <template v-slot="scope">
                <el-button type="text" @click="lookGoods(scope.row)" size="mini" v-show="scope.row.path">提货函</el-button>
                <el-button type="text"  @click="lookMessage(scope.row)" size="mini">人车信息</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="billNo" label="提货单号" width="250" ></el-table-column>
            <el-table-column prop="miniBillNo" label="预提单号" width="250" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="outBillNo" label="客户单号" width="120" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="miniBillTypeName" label="单据状态" width="100" ></el-table-column>
            <el-table-column prop="plateNumber" label="车牌号" width="120" ></el-table-column>
            <el-table-column prop="primaryCustomerName" label="一级货主" width="230" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="secondaryCustomerName" label="二级货主" width="230" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="createUser" label="创建人" width="150" ></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="180" :formatter="dateTimeFormat" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="driverConfirmDate" label="司机确认时间" width="180" :formatter="dateTimeFormat" :show-overflow-tooltip="true"></el-table-column>
          </el-table>
      </div>
      <div class="pags" style="text-align: right">
        <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="formData.pageNo"
            :page-size="formData.pageSize"
            :page-sizes="[10,20,30,40,50]"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            :total="total"
        ></el-pagination>
      </div>
      <!--出库单详情-->
        <div ref="searchBox2">
          <div class="detailsTitle">
            <h4>货物明细</h4>
          </div>
          <p class="detailsTitle-sum">
            <span>总吨数：<span class="num">{{allWeight}}</span>&nbsp;吨</span><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;总件数：<span class="num">{{allNumber}}</span>&nbsp;件</span>
          </p>
        </div>
          <!--详情表格-->
          <div class="ruKuZuoyeWarp-body-detailsTab">
              <div class="ruKuZuoyeWarp-body-table" :style="{height:detailsH}">
                <el-table
                  height="100%"
                  border
                  bordersize="mini"
                  size="mini"
                  ref="tabref"
                  :data="miniBillDetailList"
                  style="width:100%"
                  highlight-current-row
                  :header-cell-style="{background:'#F5F5F5',color:'black'}"
                >
                  <el-table-column prop="steelMillName" label="产地" width="250px"></el-table-column>
                  <el-table-column prop="productTypeName" label="货物类型"></el-table-column>
                  <el-table-column prop="model" label="材质"></el-table-column>
                  <el-table-column prop="specification" label="规格"></el-table-column>
                  <el-table-column prop="number" label="件数"></el-table-column>
                  <el-table-column prop="weight" label="重量（吨）">
                    <template v-slot="scope">
                      <div>
                        <span v-if="scope.row.weight == undefined || scope.row.weight == ''">0</span>
                        <span v-else>{{Number(scope.row.weight).toFixed(4)}}</span>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
          </div>

    </div>
     <!-- 人车信息 -->
    <rcDialog v-if="RCVisible" :RCVisible.sync='RCVisible' :identityNo="identityNo" :vhcNo="vhcNo" :driverName="driverName" :telephone="telephone"></rcDialog>
    <add-yu-ti-plan v-if="addYuTi" :addYuTi.sync='addYuTi' :planData="planData"></add-yu-ti-plan>
  </div>
</template>

<script>
import {
  getRelationCustomer,
  getTEmptyMiniBillMasterList, // 列表
  delEmptyMiniBillForWms // 删除
} from '@/api/wms-stock'
import { getSBillFileUrl } from '@/api/soc-stock'
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import { dateTimeFormat } from '@/utils/util'
import addYuTiPlan from './addYuTiPlan.vue'
import rcDialog from '../../yycRuKu/yycChuanYun/dialog/RCdialog.vue'
export default {
  name: 'YtdRecord',
  components: { rcDialog, addYuTiPlan },
  data () {
    return {
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      total: 0,
      formData: {
        pageNo: 1,
        pageSize: 20,
        miniBillType: '1', // （预提单状态 必填 ※注：0-未到场 1-已到场 2-分配完成 3-已出库）
        driverFlag: '', // （司机端标识 非必填  ※注：司机端必传固定值“1”）
        organizationId: localStorage.getItem('tenantCode'), // （仓储租户id 非必填  ※注：仓储端必填）
        plateNumberList: '', // （司机所有绑定的车牌号String数组 非必填  ※注：司机端必填）
        idNumber: '', // （司机身份证 非必填）
        plateNumber: '', // （车牌号 非必填）
        miniBillNo: '', // （预提单号  非必填）
        billNo: '', // （提单号 非必填）
        dateStart: '', // （创建开始时间 非必填）
        dateEnd: '', // （创建结束时间 非必填）
        primaryCustomerTaxId: '', // （一级货主id）
        secondaryCustomerTaxId: '', // （二级货主id）
        outBillNo: '' // （客户单号）
      },
      btnIdArr: [
        '00cP005B001',
        '00cP005B002',
        '00cP005B003',
        '00cP005B004',
        '00cP005B005',
        '00cP005B006',
        '00cP005B007',
        '00cP005B008',
        '00cP005B009',
        '00cP005B00A',
        '00cP005B00B',
        '00cP005B00C'
      ],
      btnFlg: [],
      tableData: [],
      HZData: [],
      h: 500,
      xuanzhongArr: null,
      detailsH: '200px',
      miniBillTypeData: [
        {
          value: '0',
          label: '未到场'
        },
        {
          value: '1',
          label: '已到场'
        },
        {
          value: '2',
          label: '分配完成'
        },
        {
          value: '3',
          label: '已出库'
        }
      ],
      allWeight: 0,
      allNumber: 0,
      miniBillDetailList: [],
      RCVisible: false,
      identityNo: '',
      vhcNo: '',
      telephone: '',
      driverName: '',
      addYuTi: false,
      planData: {}
    }
  },
  props: {
    YTDVisible: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    // 列表查询
    JfgetConfirmedExpLists () {
      getTEmptyMiniBillMasterList(this.formData)
        .then(res => {
          this.tableData = res.list
          this.total = res.total
          if (res.list.length > 0) {
            this.xuanzhongArr = res.list[0]
            this.$nextTick(() => {
              this.$refs.tableData.setCurrentRow(res.list[0])
            })
            if (res.list[0].miniBillDetailList) {
              this.miniBillDetailList = res.list[0].miniBillDetailList
            }
            if (res.list[0].all) {
              this.allWeight = res.list[0].all.allWeight
              this.allNumber = res.list[0].all.allNumber
            }
          } else {
            this.tableList = []
            this.total = 0
            this.allWeight = '0'
            this.allNumber = '0'
            this.miniBillDetailList = []
          }
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 提货函
    lookGoods (row) {
      if (row.path) {
        let formData = new FormData()
        formData.append('url', row.path)
        getSBillFileUrl(formData).then(res => {
          this.$router.push({
            name: 'Pdf',
            query: { path: res }
          })
        })
      }
    },
    // 人车信息
    lookMessage (row) {
      this.RCVisible = true
      this.identityNo = row.idNumber
      this.vhcNo = row.plateNumber
      this.telephone = row.telephone
      this.driverName = row.driverName
    },
    chaxun () {
      this.JfgetConfirmedExpLists()
    },
    chongzhi () {
      this.formData = {
        pageNo: 1,
        pageSize: 20,
        miniBillType: '1',
        driverFlag: '',
        organizationId: localStorage.getItem('tenantCode')
      }
      this.JfgetConfirmedExpLists()
    },
    handleCurrentChange (val) {
      this.formData.pageNo = val
      this.JfgetConfirmedExpLists()
    },
    handleSizeChange (val) {
      this.formData.pageSize = val
      this.JfgetConfirmedExpLists()
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          this.HZData = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    dianjiTable (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      if (this.xuanzhongArr.miniBillDetailList) {
        this.miniBillDetailList = this.xuanzhongArr.miniBillDetailList
      }
      if (this.xuanzhongArr.all) {
        this.allWeight = this.xuanzhongArr.all.allWeight
        this.allNumber = this.xuanzhongArr.all.allNumber
      }
    },
    // 删除
    deletedClcik () {
      if (this.xuanzhongArr == null) {
        this.$message({ message: '请选择一条数据', type: 'error' })
      } else if (this.xuanzhongArr.miniBillType == '1') {
        this.$confirm('确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delEmptyMiniBillForWms({
            miniBillId: this.xuanzhongArr.miniBillId
          })
            .then(res => {
              this.$message({ message: '删除成功', type: 'success' })
              this.JfgetConfirmedExpLists()
            })
            .catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
        }).catch(() => {

        })
      } else {
        DonMessage.error('只有已到场状态的数据才能删除')
      }
    },
    addPlan () {
      if (this.xuanzhongArr == null) {
        this.$message({ message: '请选择一条数据', type: 'error' })
      } else if (this.xuanzhongArr.miniBillType == '1') {
        this.addYuTi = true
        this.planData = this.xuanzhongArr
      } else {
        DonMessage.error('该条数据不能添加出库计划')
      }
    }

  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/yycCKTiDan')
    this.getRelationCustomerS()
    this.JfgetConfirmedExpLists()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let h2 = this.$refs.searchBox2.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = 0.6 * pH - h - 165 + 'px'
    this.detailsH = 0.4 * pH - h2 - 70 + 'px'
  }
}
</script>

<style scoped lang='less'>
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
